var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLineLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ArrowLineLeft"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4254 4.55806C13.6915 4.80214 13.6915 5.19786 13.4254 5.44194L8.9375 9.55806C8.67138 9.80214 8.67138 10.1979 8.9375 10.4419L13.4254 14.5581C13.6915 14.8021 13.6915 15.1979 13.4254 15.4419C13.1593 15.686 12.7278 15.686 12.4617 15.4419L7.97378 11.3258C7.17541 10.5936 7.17541 9.40641 7.97378 8.67418L12.4617 4.55806C12.7278 4.31398 13.1593 4.31398 13.4254 4.55806Z",
    fill: "#1C1C1C",
    fillOpacity: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLineLeft);
export default __webpack_public_path__ + "static/media/ArrowLineLeft.53a321980709d875ce33d756ce8103ae.svg";
export { ForwardRef as ReactComponent };